import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#d32f2f', cx: '12', cy: '12', r: '12' }),
    React.createElement("circle", { key: '1', fill: '#FFFFFF', cx: '12', cy: '12', r: '10' }),
    React.createElement("path", { key: '3', fill: '#000000', d: 'M15.4,5.9V18c0,0.4-0.3,0.8-0.7,0.8H9.3c-0.4,0-0.7-0.3-0.7-0.8V5.9c0-0.4,0.3-0.8,0.7-0.8h1.4V3.7h2.7v1.5h1.4\n\t\tC15.1,5.2,15.4,5.5,15.4,5.9z M14,6.7H10v7.5H14V6.7z' }),
], 'TransportConditionVoltage');
const TransportConditionVoltageIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(TransportConditionVoltageIcon);
